export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        online: (state) => state.online,
    },

    mutations: {
        setConnectionStatus(state, isOnline) {
            state.online = isOnline;
        },
        reset(state) {
            Object.assign(state, getDefaultState());
        },
    },

};

function getDefaultState() {
    return {
        online: navigator.onLine,
    };
}
